import FilterFacilities from './FilterFacilities';

export default FilterFacilities;
